import * as R from "ramda";
import lens from "../lenses/billing-report";
import { isPresent } from "../../utils";

const columnOrder = [
  "orderId",
  "subtotal",
  "convenienceFee",
  "certificationFee",
  "totalCharged",
  "date",
  "userName",
  "userEmail",
  "numberOfItems",
];

export default {
  root: R.view(lens),
  data: R.view(lens.data),
  loading: R.view(lens.loading),
  csvUrl: R.view(lens.csvUrl),
  totals: R.view(lens.totals),
  pagination: (state) => {
    const pagination = R.view(lens.pagination, state);

    return {
      ...pagination,
      currentPage: R.propOr(0, "offset", pagination) + 1,
    };
  },

  tableView: (state) => {
    const rawData = R.view(lens.data, state);
    const data = isPresent(rawData) ? rawData : [];

    if (R.isEmpty(data.rows)) return [];

    return data.map((item) => columnOrder.map((key) => item[key]));
  },
};
